export const ASSISTANT_CONVERSATION_QUERY_OPTIONS = {
  retry: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
  staleTime: 0,
  gcTime: 0,
  refetchOnMount: "always",
} as const;
